import { render, staticRenderFns } from "./ResourcesTransfer.vue?vue&type=template&id=567ab4c6&scoped=true&"
import script from "./ResourcesTransfer.vue?vue&type=script&lang=js&"
export * from "./ResourcesTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesTransfer.vue?vue&type=style&index=0&id=567ab4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ab4c6",
  null
  
)

export default component.exports